import * as Sentry from '@sentry/browser'
import React, { useState, useEffect } from 'react'
import { flowRight as compose } from 'lodash'
import { useTranslation } from 'react-i18next'

import { BranchService, Branch, initialBranchDetail } from 'features/Branch'
import { useFindOneById } from 'features/Product/service'
import {
  ProductDetail as Content,
  renderBreadcrumbsDetail,
} from 'features/Product'

import { Button } from 'components'
import { useBreadcrumbs } from 'helpers/hooks'
import { withBackOfficeCms } from 'helpers/hocs'
import { routes } from 'helpers/routes'
import { RouteChildrenProps } from 'react-router'
import { useParams, generatePath } from 'react-router-dom'

const ProductDetail = ({
  history,
}: RouteChildrenProps<{ branchId: string }>): JSX.Element => {
  const [loadingBranch, setLoadingBranch] = useState<boolean>(false)
  const [branch, setBranch] = useState<Branch>(initialBranchDetail)

  const { branchId, productId } =
    useParams<{ branchId: string; productId: string }>()

  const [{ data: product, loading }] = useFindOneById(productId)

  const { t } = useTranslation(['layout', 'common'])

  const base = 'con-product'

  useBreadcrumbs(renderBreadcrumbsDetail(branchId, productId))

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    try {
      setLoadingBranch(true)
      const content = await BranchService.findBranchById(branchId)
      setBranch(content.data || initialBranchDetail)
      setLoadingBranch(false)
    } catch (error) {
      Sentry.captureException(error)
    }
  }

  return (
    <div className={`${base}__container ${base}__container-detail`}>
      <Content
        dataProduct={product}
        dataBranch={branch}
        loading={loading && loadingBranch}
      />
      <div className={`${base}__con-detail-bottom`}>
        <Button
          className={`${base}__form-btn-detail`}
          onClick={() =>
            history.push(
              generatePath(routes.branch.product.edit.path, {
                branchId,
                productId,
              }),
            )
          }
          variants='primary'
        >
          {t('common:edit.button')}
        </Button>
      </div>
    </div>
  )
}

export default compose(withBackOfficeCms)(ProductDetail)
